import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Divisions from './components/Divisions';
import Showcase from './components/Showcase';
import Industries from './components/Industries';
import ContactSection from './components/ContactSection';
import Chatbot from './components/Chatbot';
import ElectronicSecurity from './components/ElectronicSecurity';
import Manufacturing from './components/Manufacturing';
import Marketing from './components/Marketing';
import About from './components/About';
import IndustriesPage from './components/IndustriesPage';
import ContactPage from './components/ContactPage';
import TermsPage from './components/TermsPage';
import CookiePolicyPage from './components/CookiePolicyPage';
import CookieConsent from './components/CookieConsent';

function Landing() {
  useEffect(() => {
    document.title = 'Electronico Holdings \u2014 Innovating Tomorrow, Today';
  }, []);
  useEffect(() => {
    const hash = window.location.hash ? window.location.hash.replace('#', '') : null;
    if (!hash) return;
    let tries = 0;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        const prev = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        const y = el.getBoundingClientRect().top + window.scrollY - 90;
        (document.scrollingElement || document.documentElement).scrollTop = y;
        setTimeout(() => {
          const el2 = document.getElementById(hash);
          if (el2) {
            const y2 = el2.getBoundingClientRect().top + window.scrollY - 90;
            (document.scrollingElement || document.documentElement).scrollTop = y2;
          }
          document.documentElement.style.scrollBehavior = prev;
        }, 700);
      } else if (tries < 25) {
        tries += 1;
        setTimeout(tryScroll, 100);
      }
    };
    const t = setTimeout(tryScroll, 250);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="relative min-h-screen bg-[#0a1526] text-white">
      <Navbar />
      <main>
        <Hero />
        <Divisions />
        <Showcase />
        <Industries />
        <ContactSection />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/divisions/electronic-security" element={<ElectronicSecurity />} />
        <Route path="/divisions/contract-manufacturing" element={<Manufacturing />} />
        <Route path="/divisions/multimedia-marketing" element={<Marketing />} />
        <Route path="/about" element={<About />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
      </Routes>
      <Chatbot />
      <Toaster />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
